export default __webpack_public_path__ + "static/media/arras18.46bdcd0f.jpg";